/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useEffect } from "react";
import { setDuration } from "~/lib/store/slice/audioSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import AudioPlayerQueueComponent from "./AudioPlayerQueueComponent";

const AudioPlayerModes = () => {
  const dispatch = useAppDispatch();
  const { currentTime, duration, playbackSpeed, progress } = useAppSelector((state) => state.nityNiyam);

  useEffect(() => {
    dispatch(setDuration(duration));
  }, [playbackSpeed, dispatch, duration]);

  return (
    <div className="w-full" role="presentation">
      <div className="w-full mt-2 max-h-[350px] 2xl:max-h-[400px] overflow-y-auto ">
        <AudioPlayerQueueComponent />
      </div>
    </div>
  );
};

export default AudioPlayerModes;
